import Vue from 'vue';
import Vuex from 'vuex';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {        
        VuexZipcode: '',
        VuexRentalContainersList: null,
        VuexPredelivery: {
            movecontainers: null,
            rentalsduration: '',
            doordirection: null,
            deliveryspace: null,
            containercondition: null,
            twomonths:null,
            deliveryinstructions: '',
            deliveryname: '',
            deliveryphone: '',            
            nonacceptabledates: [],
            deliverysurfacetype: '',
            softSurfaceAcknowledge: false
        },
        VuexCartItem: [],        
        terms_conditions: false,
        country_code: ''        
    },
    getters,
    mutations,
    actions,    
});